var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { EntityMeta, entityMetaDateTransform } from './entity-meta';
var cls = classNames('post-meta');
export var PostMetaDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    font-size: 1em;\n  "], ["\n    font-size: 1em;\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled(EntityMeta)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles)
};
export var PostMeta = function (props) {
  var className = props.className,
    children = props.children,
    entity = props.entity;
  return React.createElement(My.Container, {
    entity: entity,
    fields: ['published', 'authors'],
    fieldTransforms: {
      published: entityMetaDateTransform,
      authors: function (values) {
        return values === null || values === void 0 ? void 0 : values.map(function (author) {
          return author.name;
        }).join(', ');
      }
    },
    className: cls.name(className)
  });
};
PostMeta.defaultProps = PostMetaDefaultProps;
PostMeta.cls = cls;
var templateObject_1, templateObject_2;